module.exports = __webpack_public_path__ + "media/SWV-I_Gruppendiagnose_3_Falsche_Bündelungseinheit.eb788815.mp3";